// src/marketplace/catalog.ts
// The local-first marketplace catalog. Lists every plugin a user can install.
//
// v1 model (shipping now): plugins are bundled at build time, so "install" means
// flipping the installed flag and seeding default config. This is the same UX as a
// remote marketplace — the install button behaves identically — but every plugin the
// catalog references is already in the bundle, which is why install is instant.
//
// Adding a new plugin is simple and non-technical:
//   1. Drop a folder in src/plugins/<id>/ with manifest.json + plugin.tsx + README.md
//   2. Add an entry here with `id`, `featured`, and a tagline
//   3. Rebuild. The registry auto-discovers it; this file tells the marketplace to show it.
import { loadRegistry } from '../plugins/registry';
export const BUNDLED = [
    { id: 'csv-exporter', tagline: 'Download everything as a spreadsheet.', featured: true },
    { id: 'auto-reply', tagline: 'Thank happy customers without lifting a finger.', featured: true },
    { id: 'weekly-digest', tagline: 'A short summary of your week, every week.', featured: true },
    { id: 'google-business-connector', tagline: 'Pull Google reviews in and post replies back.', featured: true },
    { id: 'yelp-connector', tagline: 'Pull Yelp reviews into ReviewRadar.', featured: false },
];
export function resolveCatalog() {
    const registry = loadRegistry();
    const out = [];
    for (const entry of BUNDLED) {
        const r = registry[entry.id];
        if (!r)
            continue; // catalog entry pointed at a missing plugin folder — skip it quietly
        out.push({ ...entry, manifest: r.manifest });
    }
    return out;
}
